module.exports = __webpack_public_path__ + "img/IMG_4092.426a40aa.jpg";